import cn from 'classnames';
import Avatar from '@/assets/images/A_UserAvatar.png';
import { getMediaUrl } from '@/utils/mediaUrl';
import { initialsOf } from '@/utils/chat';
import styles from './A_ChatAvatar.module.css';

interface A_ChatAvatarProps {
  /** Название диалога или имя собеседника — источник инициалов. */
  title: string;
  src?: string | null;
  /** Группа без картинки показывает инициалы на цветной подложке. */
  isGroup?: boolean;
  size?: number;
  className?: string;
}

export default function A_ChatAvatar({
  title,
  src,
  isGroup = false,
  size = 48,
  className,
}: A_ChatAvatarProps) {
  const dimensions = { width: size, height: size };

  if (!src && isGroup) {
    return (
      <div
        className={cn(styles.initials, className)}
        style={{ ...dimensions, fontSize: Math.round(size / 2.6) }}
        aria-hidden='true'
      >
        {initialsOf(title)}
      </div>
    );
  }

  return (
    <img
      src={getMediaUrl(src?.trim() || Avatar)}
      alt={title}
      className={cn(styles.avatar, className)}
      style={dimensions}
    />
  );
}
